export default "/assets/images/mila-green.1790b6f0bac6c6ac.png";